/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { AccessGroupModel } from '../models/AccessGroupModel';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class AccessGroupService {
    constructor(public readonly http: HttpClient) {}
    /**
     * @returns AccessGroupModel
     * @throws ApiError
     */
    public accessGroupGet(): Observable<Array<AccessGroupModel>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/accessgroups',
        });
    }
}
